import * as React from 'react';
import { QuantityContainerButton } from './components/QuantityContainerButton/QuantityContainerButton.js';

const QuantityContainer = ({ items , selected , handleClick  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "quantity-container"
    }, items.map((item)=>/*#__PURE__*/ React.createElement(QuantityContainerButton, {
            key: item.value,
            item: item,
            isSelected: selected.value === item.value,
            onClick: ()=>handleClick(item)
        })
    ));
};

export { QuantityContainer };
//# sourceMappingURL=QuantityContainer.js.map
